import React from 'react';
import { Accordion, AccordionItemData } from './Accordion';
const objeciones: AccordionItemData[] = [{
  title: '“No tengo tiempo de leer un material largo”',
  body: 'Cada tema es una ficha de 1 página. La leés en 5 minutos antes de entrar al aula y ya tenés la clase resuelta.'
}, {
  title: '“¿Sirve para el programa argentino?”',
  body: 'Sí. Está armado para secundaria en Argentina y el planificador está mapeado a los 4 bimestres con NAP orientativo.'
}, {
  title: '“¿Y si no puedo editar los archivos?”',
  body: 'Los bonos vienen en Excel y Word editables: cambiás nombres, cursos y fechas sin programas raros. Las fichas son PDF listas para imprimir.'
}, {
  title: '“$22.900 me parece mucho”',
  body: 'Es un pago único, menos de lo que gastás en fotocopias en un bimestre, y te ahorra decenas de horas de planificación cada año.'
}, {
  title: '“No tengo laboratorio en mi escuela”',
  body: 'Por eso incluimos “Laboratorios sin laboratorio”: 15 experimentos con materiales caseros o de bajo costo.'
}, {
  title: '“¿Cómo lo recibo?”',
  body: 'Apenas confirmás el pago te llega el acceso a tu correo. Descargás todo al instante, sin esperar envíos.'
}];
export function Objeciones() {
  return <section className="px-4 pb-8 pt-2" aria-labelledby="obj-title" data-id="element-81" data-mp="40lzchvdfws3">
      <h2 id="obj-title" className="text-center font-display text-lg font-extrabold text-white" data-id="element-82" data-mp="3vauf8nfxf2xi">
        Antes de decidir, resolvamos tus dudas
      </h2>
      <div className="mt-4" data-id="element-83" data-mp="rtm40mfpf1br">
        <Accordion items={objeciones} data-id="element-84" data-mp="rtceezykmw6l" />
      </div>
    </section>;
}